function getFocusableElements(container) {
  if (!container) return;

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling?.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!container) return;

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    const locale = document.documentElement.lang || undefined;
    const activeCurrency = window?.Shopify?.currency?.active || "USD";
    try {
      this.currencyFormatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: activeCurrency,
      });
    } catch (_e) {
      this.currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
    }
    this.refreshBasePrice();
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    if (this.querySelector("input").hasAttribute("data-min")) {
      this.input.min =
        Number(this.querySelector("input").getAttribute("data-min")) || 0;
    }
    if (this.querySelector("input").hasAttribute("data-max")) {
      this.input.max =
        Number(this.querySelector("input").getAttribute("data-max")) || 0;
    }
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  refreshBasePrice() {
    const priceParent = this.closest("product-info")?.querySelector(
      ".price-parent",
    );
    if (!priceParent) return;

    const basePrice = parseFloat(priceParent.getAttribute("data-base-price"));
    if (!Number.isNaN(basePrice)) this.basePrice = basePrice;

    const comparePrice = parseFloat(
      priceParent.getAttribute("data-base-compare-price"),
    );
    this.salePrice =
      !Number.isNaN(comparePrice) && comparePrice > 0 ? comparePrice : null;
  }

  updatePrice() {
    this.refreshBasePrice();
    if (Number.isNaN(this.basePrice)) return;

    const productInfo = this.closest("product-info");
    const priceContainerParent = productInfo.querySelector(".price-parent");
    const quantity = parseInt(this.input.value, 10) || 1;

    /* Add replaceNode to override recharge's price update */
    if (priceContainerParent.hasAttribute("data-price-mutation-watcher")) {
      const priceContainerParentClone = priceContainerParent.cloneNode(true);
      priceContainerParentClone.removeAttribute("data-price-mutation-watcher");
      priceContainerParent.replaceWith(priceContainerParentClone);
    }
    productInfo
      .querySelector(".price .price__regular [data-currency-price]")
      .setAttribute(
        "data-currency-price",
        parseFloat(this.basePrice) * quantity,
      );
    productInfo.querySelector(
      ".price .price__regular [data-currency-price]",
    ).textContent = this.currencyFormatter.format(
      (parseFloat(this.basePrice) / 100.0) * quantity,
    );
    if (this.salePrice && this.salePrice > this.basePrice) {
      productInfo
        .querySelector(".price .price__sale [data-currency-price]")
        .setAttribute(
          "data-currency-price",
          parseFloat(this.salePrice) * quantity,
        );
      productInfo.querySelector(
        ".price .price__sale [data-currency-price]",
      ).textContent = this.currencyFormatter.format(
        (parseFloat(this.salePrice) / 100.0) * quantity,
      );
    }
    if (
      productInfo.querySelector(
        ".product-form__buttons .product-form__submit [data-currency-price]",
      )
    ) {
      productInfo
        .querySelector(
          ".product-form__buttons .product-form__submit [data-currency-price]",
        )
        .setAttribute(
          "data-currency-price",
          parseFloat(this.basePrice) * quantity,
        );
      productInfo.querySelector(
        ".product-form__buttons .product-form__submit [data-currency-price]",
      ).textContent = this.currencyFormatter.format(
        (parseFloat(this.basePrice) / 100.0) * quantity,
      );
    }
    productInfo
      .querySelector(".price-parent")
      .setAttribute("data-price-mutation-watcher", "");
  }

  onInputChange(event) {
    this.updatePrice();
    this.dispatchEvent(
      new CustomEvent("QuantityChange", {
        detail: { value: this.input.value },
      }),
    );
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/**
 * Creates a throttled function that only invokes the provided function at most once per every wait milliseconds.
 * @param {Function} func - The function to throttle.
 * @param {number} limit - The number of milliseconds to throttle invocations to.
 * @returns {Function} Returns the new throttled function.
 */
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(
        function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        },
        limit - (Date.now() - lastRan),
      );
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dots = this.querySelectorAll(".slider-counter__link");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    if (this.dots) {
      this.dots.forEach((dot) => {
        dot.addEventListener("click", this.onDotClick.bind(this));
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });

    if (this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].classList.add(
        "slider-counter__link--active",
      );
      this.sliderControlButtons[this.currentPage - 1].setAttribute(
        "aria-current",
        true,
      );
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  onDotClick(event) {
    event.preventDefault();
    this.slideScrollPosition = 0;
    // Check if the target is the span, and if so, get the parent slider-counter__link
    const dotLink = event.target.closest(".slider-counter__link");
    const firstSlide = event.target.closest("slider-component");

    if (dotLink) {
      const index = dotLink.getAttribute("data-index");
      this.currentPage = index - 1;

      const sliderComponent = event.target.closest("slider-component");
      if (sliderComponent) {
        // Find the first li child inside the slider-component
        this.firstSlide = sliderComponent.querySelector("li");

        if (this.firstSlide) {
          this.slideScrollPosition =
            this.firstSlide.clientWidth * this.currentPage;
          this.slider.scrollTo({
            left: this.slideScrollPosition,
          });
        }
      }
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      try {
        const currentFieldsets = document.querySelectorAll(
          "fieldset.product-form__input",
        );
        const variantData = this.getVariantData();
        let inputPos = 0;
        let inputName = "";
        currentFieldsets.forEach((fieldset, index) => {
          const inputs = fieldset.querySelectorAll("input");

          inputs.forEach((input) => {
            if (
              input.getAttribute("data-pos") == "2" ||
              input.getAttribute("data-pos") === "3"
            ) {
              if (input.checked) {
                input.setAttribute("data-option-exists", false);
                inputPos = parseInt(input.getAttribute("data-pos"));
                inputName = input.getAttribute("name");
                document
                  .querySelector(
                    `fieldset.product-form__input input[name="${inputName}"][data-option-exists="true"] + label`,
                  )
                  .click();
              }
            }
          });
        });
      } catch (e) {
        console.error("Error setting attributes for unavailable variant", e);
        window.location.reload();
      }
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.syncQuantityBasePriceFromVariant();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  syncQuantityBasePriceFromVariant() {
    if (!this.currentVariant) return;

    const productInfo = this.closest("product-info");
    const priceParent = productInfo?.querySelector(".price-parent");
    if (priceParent) {
      priceParent.setAttribute("data-base-price", this.currentVariant.price);
      priceParent.setAttribute(
        "data-base-compare-price",
        this.currentVariant.compare_at_price || "",
      );
    }

    const quantityInput = productInfo?.querySelector("quantity-input");
    if (quantityInput?.updatePrice) {
      quantityInput.updatePrice();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value"),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          if (source.hasAttribute("data-base-price")) {
            destination.setAttribute(
              "data-base-price",
              source.getAttribute("data-base-price"),
            );
          }
          if (source.hasAttribute("data-base-compare-price")) {
            destination.setAttribute(
              "data-base-compare-price",
              source.getAttribute("data-base-compare-price"),
            );
          }
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        const quantityInput = this.closest("product-info")?.querySelector(
          "quantity-input",
        );
        if (quantityInput?.updatePrice) {
          quantityInput.updatePrice();
        }

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );

        const addButtonsUpdated = [
          html.getElementById(`ProductSubmitButtonMain-${sectionId}`),
          html.getElementById(`ProductSubmitButtonSticky-${sectionId}`),
        ];

        addButtonsUpdated.forEach((addButtonUpdated) => {
          if (!addButtonUpdated) return;

          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            window.variantStrings.soldOut,
          );
        });

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        try {
          const fieldsets = html.querySelectorAll("fieldset");
          const currentFieldsets = document.querySelectorAll("fieldset");
          fieldsets.forEach((fieldset, index) => {
            const allInput = fieldset.querySelectorAll("input");
            const fieldsetIndex = index;
            allInput.forEach((input) => {
              const currentInput = currentFieldsets[
                fieldsetIndex
              ].querySelector(`input[value="${input.value}"]`);
              currentInput.setAttribute(
                "data-option-exists",
                input.getAttribute("data-option-exists"),
              );

              // Check if input has data-pos 2 or 3 and data-option-exists is false
              const dataPos = input.getAttribute("data-pos");
              const dataOptionExists = input.getAttribute("data-option-exists");

              if (
                (dataPos === "2" || dataPos === "3") &&
                dataOptionExists === "false" &&
                currentInput.checked
              ) {
                // Find the first input in currentFieldsets[fieldsetIndex] with data-option-exists="true"
                const currentFieldset = currentFieldsets[fieldsetIndex];
                const firstAvailableInput = currentFieldset.querySelector(
                  `input[data-option-exists="true"]`,
                );

                if (firstAvailableInput) {
                  // Find and click the associated label
                  const label = currentFieldset.querySelector(
                    `label[for="${firstAvailableInput.id}"]`,
                  );
                  if (label) {
                    label.click();
                  }
                }
              }
            });
          });
        } catch (e) {
          console.error("Error setting attributes", e);
        }

        document.dispatchEvent(new CustomEvent("ProductInfo:Variant:Changed"));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = [
      document.getElementById(`product-form-${this.dataset.section}`),
      document.querySelector(".variants-dropdowns"),
    ];

    if (!productForms.length) return;

    productForms.forEach((productForm) => {
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      const price = document.getElementById(`price-${this.dataset.section}`);
      const priceItem =
        price?.querySelector(".price-item[data-currency-price]") ||
        price?.querySelector(".price-item");
      const priceValue = priceItem?.getAttribute("data-currency-price") || "";
      const priceText = priceItem?.textContent || "";

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled foo");
        if (text)
          addButtonText.innerHTML = `${text} - <span data-currency-price="${priceValue}">${priceText}</span>`;
      } else {
        addButton.removeAttribute("disabled");
        addButtonText.innerHTML = `${window.variantStrings.addToCart} - <span data-currency-price="${priceValue}">${priceText}</span>`;
      }
      try {
        if (document.querySelector("#klaviyo-bis-location")) {
          if (disable && text.toLowerCase() === "sold out") {
            document
              .querySelector("#klaviyo-bis-location")
              .classList.add("has-oos");
            document
              .querySelector("#klaviyo-bis-location")
              .classList.remove("has-unavailable");
          } else if (disable && text.toLowerCase() === "") {
            document
              .querySelector("#klaviyo-bis-location")
              .classList.remove("has-oos");
            document
              .querySelector("#klaviyo-bis-location")
              .classList.add("has-unavailable");
          } else {
            document
              .querySelector("#klaviyo-bis-location")
              .classList.remove("has-oos");
            document
              .querySelector("#klaviyo-bis-location")
              .classList.remove("has-unavailable");
            if (!disable) {
              if (
                document.querySelector(
                  "product-form form.form .product-form__buttons .product-form__submit",
                )
              ) {
                document
                  .querySelector(
                    "product-form form.form .product-form__buttons .product-form__submit",
                  )
                  .classList.remove("product-form__submit--sold-out");
              }
            }
          }
        }
      } catch {
        console.error("Error setting class");
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    // const button = document.getElementById(
    //   `product-form-${this.dataset.section}`
    // );
    const productForms = [
      document.getElementById(`product-form-${this.dataset.section}`),
      document.getElementById(`product-form-sticky-${this.dataset.section}`),
    ];

    productForms.forEach((productForm) => {
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(
        `Inventory-${this.dataset.section}`,
      );
      const sku = document.getElementById(`Sku-${this.dataset.section}`);

      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("visibility-hidden");
      if (inventory) inventory.classList.add("visibility-hidden");
      if (sku) sku.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          let sliderElem = this.querySelector("ul");
          let li_length = sliderElem.querySelectorAll("li").length;
          if (li_length > 1) {
            $(sliderElem).slick({
              dots: false,
              arrows: false,
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 1,
              loop: true,
              autoplay: false,
              autoplay: true,
              responsive: [
                {
                  breakpoint: 750,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            });
          }
          document.dispatchEvent(
            new CustomEvent("Product:Recommendations:Loaded"),
          );
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/*! lazysizes - v3.0.0 */
!(function (a, b) {
  var c = b(a, a.document);
  ((a.lazySizes = c),
    "object" == typeof module && module.exports && (module.exports = c));
})(window, function (a, b) {
  "use strict";
  if (b.getElementsByClassName) {
    var c,
      d = b.documentElement,
      e = a.Date,
      f = a.HTMLPictureElement,
      g = "addEventListener",
      h = "getAttribute",
      i = a[g],
      j = a.setTimeout,
      k = a.requestAnimationFrame || j,
      l = a.requestIdleCallback,
      m = /^picture$/i,
      n = ["load", "error", "lazyincluded", "_lazyloaded"],
      o = {},
      p = Array.prototype.forEach,
      q = function (a, b) {
        return (
          o[b] || (o[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")),
          o[b].test(a[h]("class") || "") && o[b]
        );
      },
      r = function (a, b) {
        q(a, b) ||
          a.setAttribute("class", (a[h]("class") || "").trim() + " " + b);
      },
      s = function (a, b) {
        var c;
        (c = q(a, b)) &&
          a.setAttribute("class", (a[h]("class") || "").replace(c, " "));
      },
      t = function (a, b, c) {
        var d = c ? g : "removeEventListener";
        (c && t(a, b),
          n.forEach(function (c) {
            a[d](c, b);
          }));
      },
      u = function (a, c, d, e, f) {
        var g = b.createEvent("CustomEvent");
        return (g.initCustomEvent(c, !e, !f, d || {}), a.dispatchEvent(g), g);
      },
      v = function (b, d) {
        var e;
        !f && (e = a.picturefill || c.pf)
          ? e({ reevaluate: !0, elements: [b] })
          : d && d.src && (b.src = d.src);
      },
      w = function (a, b) {
        return (getComputedStyle(a, null) || {})[b];
      },
      x = function (a, b, d) {
        for (d = d || a.offsetWidth; d < c.minSize && b && !a._lazysizesWidth; )
          ((d = b.offsetWidth), (b = b.parentNode));
        return d;
      },
      y = (function () {
        var a,
          c,
          d = [],
          e = [],
          f = d,
          g = function () {
            var b = f;
            for (f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
            a = !1;
          },
          h = function (d, e) {
            a && !e
              ? d.apply(this, arguments)
              : (f.push(d), c || ((c = !0), (b.hidden ? j : k)(g)));
          };
        return ((h._lsFlush = g), h);
      })(),
      z = function (a, b) {
        return b
          ? function () {
              y(a);
            }
          : function () {
              var b = this,
                c = arguments;
              y(function () {
                a.apply(b, c);
              });
            };
      },
      A = function (a) {
        var b,
          c = 0,
          d = 125,
          f = 666,
          g = f,
          h = function () {
            ((b = !1), (c = e.now()), a());
          },
          i = l
            ? function () {
                (l(h, { timeout: g }), g !== f && (g = f));
              }
            : z(function () {
                j(h);
              }, !0);
        return function (a) {
          var f;
          ((a = a === !0) && (g = 44),
            b ||
              ((b = !0),
              (f = d - (e.now() - c)),
              0 > f && (f = 0),
              a || (9 > f && l) ? i() : j(i, f)));
        };
      },
      B = function (a) {
        var b,
          c,
          d = 99,
          f = function () {
            ((b = null), a());
          },
          g = function () {
            var a = e.now() - c;
            d > a ? j(g, d - a) : (l || f)(f);
          };
        return function () {
          ((c = e.now()), b || (b = j(g, d)));
        };
      },
      C = (function () {
        var f,
          k,
          l,
          n,
          o,
          x,
          C,
          E,
          F,
          G,
          H,
          I,
          J,
          K,
          L,
          M = /^img$/i,
          N = /^iframe$/i,
          O = "onscroll" in a && !/glebot/.test(navigator.userAgent),
          P = 0,
          Q = 0,
          R = 0,
          S = -1,
          T = function (a) {
            (R--,
              a && a.target && t(a.target, T),
              (!a || 0 > R || !a.target) && (R = 0));
          },
          U = function (a, c) {
            var e,
              f = a,
              g =
                "hidden" == w(b.body, "visibility") ||
                "hidden" != w(a, "visibility");
            for (
              F -= c, I += c, G -= c, H += c;
              g && (f = f.offsetParent) && f != b.body && f != d;
            )
              ((g = (w(f, "opacity") || 1) > 0),
                g &&
                  "visible" != w(f, "overflow") &&
                  ((e = f.getBoundingClientRect()),
                  (g =
                    H > e.left &&
                    G < e.right &&
                    I > e.top - 1 &&
                    F < e.bottom + 1)));
            return g;
          },
          V = function () {
            var a, e, g, i, j, m, n, p, q;
            if ((o = c.loadMode) && 8 > R && (a = f.length)) {
              ((e = 0),
                S++,
                null == K &&
                  ("expand" in c ||
                    (c.expand =
                      d.clientHeight > 500 && d.clientWidth > 500 ? 500 : 370),
                  (J = c.expand),
                  (K = J * c.expFactor)),
                K > Q && 1 > R && S > 2 && o > 2 && !b.hidden
                  ? ((Q = K), (S = 0))
                  : (Q = o > 1 && S > 1 && 6 > R ? J : P));
              for (; a > e; e++)
                if (f[e] && !f[e]._lazyRace)
                  if (O)
                    if (
                      (((p = f[e][h]("data-expand")) && (m = 1 * p)) || (m = Q),
                      q !== m &&
                        ((C = innerWidth + m * L),
                        (E = innerHeight + m),
                        (n = -1 * m),
                        (q = m)),
                      (g = f[e].getBoundingClientRect()),
                      (I = g.bottom) >= n &&
                        (F = g.top) <= E &&
                        (H = g.right) >= n * L &&
                        (G = g.left) <= C &&
                        (I || H || G || F) &&
                        ((l && 3 > R && !p && (3 > o || 4 > S)) || U(f[e], m)))
                    ) {
                      if ((ba(f[e]), (j = !0), R > 9)) break;
                    } else
                      !j &&
                        l &&
                        !i &&
                        4 > R &&
                        4 > S &&
                        o > 2 &&
                        (k[0] || c.preloadAfterLoad) &&
                        (k[0] ||
                          (!p &&
                            (I ||
                              H ||
                              G ||
                              F ||
                              "auto" != f[e][h](c.sizesAttr)))) &&
                        (i = k[0] || f[e]);
                  else ba(f[e]);
              i && !j && ba(i);
            }
          },
          W = A(V),
          X = function (a) {
            (r(a.target, c.loadedClass),
              s(a.target, c.loadingClass),
              t(a.target, Z));
          },
          Y = z(X),
          Z = function (a) {
            Y({ target: a.target });
          },
          $ = function (a, b) {
            try {
              a.contentWindow.location.replace(b);
            } catch (c) {
              a.src = b;
            }
          },
          _ = function (a) {
            var b,
              d,
              e = a[h](c.srcsetAttr);
            ((b = c.customMedia[a[h]("data-media") || a[h]("media")]) &&
              a.setAttribute("media", b),
              e && a.setAttribute("srcset", e),
              b &&
                ((d = a.parentNode),
                d.insertBefore(a.cloneNode(), a),
                d.removeChild(a)));
          },
          aa = z(function (a, b, d, e, f) {
            var g, i, k, l, o, q;
            ((o = u(a, "lazybeforeunveil", b)).defaultPrevented ||
              (e && (d ? r(a, c.autosizesClass) : a.setAttribute("sizes", e)),
              (i = a[h](c.srcsetAttr)),
              (g = a[h](c.srcAttr)),
              f && ((k = a.parentNode), (l = k && m.test(k.nodeName || ""))),
              (q = b.firesLoad || ("src" in a && (i || g || l))),
              (o = { target: a }),
              q &&
                (t(a, T, !0),
                clearTimeout(n),
                (n = j(T, 2500)),
                r(a, c.loadingClass),
                t(a, Z, !0)),
              l && p.call(k.getElementsByTagName("source"), _),
              i
                ? a.setAttribute("srcset", i)
                : g && !l && (N.test(a.nodeName) ? $(a, g) : (a.src = g)),
              (i || l) && v(a, { src: g })),
              a._lazyRace && delete a._lazyRace,
              s(a, c.lazyClass),
              y(function () {
                (!q || (a.complete && a.naturalWidth > 1)) &&
                  (q ? T(o) : R--, X(o));
              }, !0));
          }),
          ba = function (a) {
            var b,
              d = M.test(a.nodeName),
              e = d && (a[h](c.sizesAttr) || a[h]("sizes")),
              f = "auto" == e;
            ((!f && l) ||
              !d ||
              (!a.src && !a.srcset) ||
              a.complete ||
              q(a, c.errorClass)) &&
              ((b = u(a, "lazyunveilread").detail),
              f && D.updateElem(a, !0, a.offsetWidth),
              (a._lazyRace = !0),
              R++,
              aa(a, b, f, e, d));
          },
          ca = function () {
            if (!l) {
              if (e.now() - x < 999) return void j(ca, 999);
              var a = B(function () {
                ((c.loadMode = 3), W());
              });
              ((l = !0),
                (c.loadMode = 3),
                W(),
                i(
                  "scroll",
                  function () {
                    (3 == c.loadMode && (c.loadMode = 2), a());
                  },
                  !0,
                ));
            }
          };
        return {
          _: function () {
            ((x = e.now()),
              (f = b.getElementsByClassName(c.lazyClass)),
              (k = b.getElementsByClassName(
                c.lazyClass + " " + c.preloadClass,
              )),
              (L = c.hFac),
              i("scroll", W, !0),
              i("resize", W, !0),
              a.MutationObserver
                ? new MutationObserver(W).observe(d, {
                    childList: !0,
                    subtree: !0,
                    attributes: !0,
                  })
                : (d[g]("DOMNodeInserted", W, !0),
                  d[g]("DOMAttrModified", W, !0),
                  setInterval(W, 999)),
              i("hashchange", W, !0),
              [
                "focus",
                "mouseover",
                "click",
                "load",
                "transitionend",
                "animationend",
                "webkitAnimationEnd",
              ].forEach(function (a) {
                b[g](a, W, !0);
              }),
              /d$|^c/.test(b.readyState)
                ? ca()
                : (i("load", ca), b[g]("DOMContentLoaded", W), j(ca, 2e4)),
              f.length ? (V(), y._lsFlush()) : W());
          },
          checkElems: W,
          unveil: ba,
        };
      })(),
      D = (function () {
        var a,
          d = z(function (a, b, c, d) {
            var e, f, g;
            if (
              ((a._lazysizesWidth = d),
              (d += "px"),
              a.setAttribute("sizes", d),
              m.test(b.nodeName || ""))
            )
              for (
                e = b.getElementsByTagName("source"), f = 0, g = e.length;
                g > f;
                f++
              )
                e[f].setAttribute("sizes", d);
            c.detail.dataAttr || v(a, c.detail);
          }),
          e = function (a, b, c) {
            var e,
              f = a.parentNode;
            f &&
              ((c = x(a, f, c)),
              (e = u(a, "lazybeforesizes", { width: c, dataAttr: !!b })),
              e.defaultPrevented ||
                ((c = e.detail.width),
                c && c !== a._lazysizesWidth && d(a, f, e, c)));
          },
          f = function () {
            var b,
              c = a.length;
            if (c) for (b = 0; c > b; b++) e(a[b]);
          },
          g = B(f);
        return {
          _: function () {
            ((a = b.getElementsByClassName(c.autosizesClass)), i("resize", g));
          },
          checkElems: g,
          updateElem: e,
        };
      })(),
      E = function () {
        E.i || ((E.i = !0), D._(), C._());
      };
    return (
      (function () {
        var b,
          d = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
          };
        c = a.lazySizesConfig || a.lazysizesConfig || {};
        for (b in d) b in c || (c[b] = d[b]);
        ((a.lazySizesConfig = c),
          j(function () {
            c.init && E();
          }));
      })(),
      {
        cfg: c,
        autoSizer: D,
        loader: C,
        init: E,
        uP: v,
        aC: r,
        rC: s,
        hC: q,
        fire: u,
        gW: x,
        rAF: y,
      }
    );
  }
});
/*! lazysizes - v3.0.0 */

document.addEventListener("Recharge:Widget:Loaded", function (event) {
  let loadingIcon = document
    .querySelector("product-form.target-form")
    .querySelector(".loading-overlay__spinner");
  if (loadingIcon) {
    loadingIcon.style.display = "none";
  }
});
